export default __webpack_public_path__ + "static/media/home.8b44262d.PNG";